import { createDomain } from "effector";

export const courseDetailsCard = createDomain("course-details-card");

export const initCourseDetailsCard = courseDetailsCard.event<{ limit: number; page: number }>();
